import { getProductUrl } from "./lib.js";
const normalizeGRSTravelData = (item) => {
  var _a, _b, _c, _d;
  const { id, product } = item || {};
  const title = product.title;
  const region = ((_b = (_a = product.attributes.region) == null ? void 0 : _a.text) == null ? void 0 : _b[0]) ?? "";
  const category = product.categories[0] ?? "";
  const productName = `${region ? region : title} ${category}`.trim();
  return {
    isCostcoTravel: true,
    isPublished: true,
    productActions: {
      type: "SeeDetails"
    },
    productInfoData: {
      partNumber: id,
      productImageUrl: (_d = (_c = product.attributes.primary_image) == null ? void 0 : _c.text) == null ? void 0 : _d[0],
      productLinkUrl: getProductUrl(product),
      productName
    }
  };
};
export {
  normalizeGRSTravelData
};
